import { FalconLanguages } from '@falcon/app/core/i18n/language';
import { DictionaryItem } from '@falcon/app/shared/models/dictionary.model';
import { FlashApplicationModel } from '@falcon/app/shared/models/flash.model';

export const BELGIUM_COUNTRY_CODE = 'BE';
export const BIC_EXEMPT_IBAN_COUNTRIES = ['BE', 'NL', 'FR', 'DE', 'LU'];

export const dictionaryItemTrackByFn = (_index: number, item: DictionaryItem): string => {
  return item.code;
};

export const flashAppTrackByFn = (_index: number, flashApp: FlashApplicationModel): string => {
  return flashApp.id;
};

export const dictionaryItemCompareFn = (option: DictionaryItem, value: DictionaryItem): boolean => {
  return option?.code === value?.code;
};

export const APP_LANGS: DictionaryItem<FalconLanguages>[] = [
  { code: FalconLanguages.NL, name: 'Dutch' },
  { code: FalconLanguages.FR, name: 'French' },
  { code: FalconLanguages.EN, name: 'English' },
];

export const MEAL_VOUCHER_TOTAL_MAX = 10;
